import { render, staticRenderFns } from "./service_cost.vue?vue&type=template&id=841a374c&scoped=true"
import script from "./service_cost.vue?vue&type=script&lang=js"
export * from "./service_cost.vue?vue&type=script&lang=js"
import style0 from "./service_cost.vue?vue&type=style&index=0&id=841a374c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a374c",
  null
  
)

export default component.exports